import { memo } from 'react';
import classNames from 'classnames';

import { TValidationHint } from '~/components/molecules/ValidationHints/validationSchema';

import { ReactComponent as Check } from '~/assets/images/iconsLibrary/check-circle.svg';
import { ReactComponent as Plus } from '~/assets/images/iconsLibrary/plus-circle.svg';

import styles from './ValidationHints.module.scss';

type TValidationHintsProps = {
  constraints: TValidationHint[];
  value: string;
};

function ValidationIcon({
  isValuePresent,
  isValueValid,
}: {
  isValuePresent: boolean;
  isValueValid: boolean;
}) {
  if (!isValuePresent) {
    return <Plus className={classNames(styles.icon, styles.circleIcon)} />;
  }
  if (!isValueValid) {
    return <Plus className={classNames(styles.icon, styles.plusIcon)} />;
  }
  return <Check className={classNames(styles.icon, styles.checkIcon)} />;
}

function ValidationHintsRenderer({
  constraints,
  value,
}: TValidationHintsProps): JSX.Element {
  return (
    <div className={styles.wrapper}>
      {constraints.map((constraint) => {
        const isValid = constraint.schema.isValidSync(value);
        return (
          <div
            className={classNames(styles.hint, {
              [styles.valid]: isValid && value,
              [styles.invalid]: !isValid && value,
            })}
            key={constraint.message}
          >
            <ValidationIcon
              isValuePresent={!!value}
              isValueValid={isValid}
            />
            {constraint.message}
          </div>
        );
      })}
    </div>
  );
}

export const ValidationHints = memo(ValidationHintsRenderer);
